
export const products = {
  'product.categories': 'Tuotekategoriat',
  'explore.solutions': 'Tutustu kattavaan ammattilais-AV-ratkaisuvalikoimaamme',
  'view.video': 'Katso tuotteen yleiskatsausvideo',
  'AV Over IP': 'AV IP:n yli',
  'ReAX Control': 'ReAX-ohjaus',
  'Meeting Room Solutions': 'Kokoushuoneratkaisut',
  'Converters/Scalers': 'Muuntimet/Skaalaimet',
  'Audio Products': 'Äänituotteet',
  'HDMI Switchers': 'HDMI-kytkimet',
  'IPBaseT': 'IPBaseT',
  'HDBaseT Products': 'HDBaseT-tuotteet',
  'Complete AV distribution solution with ultra-low latency': 'Täydellinen AV-jakeluratkaisut erittäin alhaisella viiveellä',
  'Professional control system solutions': 'Ammattimaiset ohjausjärjestelmäratkaisut',
  'Complete solutions for modern meeting spaces': 'Täydelliset ratkaisut moderneihin kokoustiloihin',
  'Professional format conversion and scaling solutions': 'Ammattimaiset formaatinmuunto- ja skaalausratkaisut',
  'Professional audio processing and playback solutions': 'Ammattimaiset äänen käsittely- ja toistoratkaisut',
  'Professional HDMI switching and distribution solutions': 'Ammattimaiset HDMI-kytkentä- ja jakeluratkaisut',
  'Advanced IP-based AV distribution platform': 'Edistynyt IP-pohjainen AV-jakelualusta',
  'Professional HDBaseT distribution solutions': 'Ammattimaiset HDBaseT-jakeluratkaisut',
  'group.not.found': 'Ryhmää ei löytynyt',
  'product.not.found': 'Tuotetta ei löytynyt',
  'return.to.home': 'Palaa etusivulle',
  'back.to.product.group': 'Takaisin tuoteryhmään',
  'overview': 'Yleiskatsaus',
  'full.description': 'Täysi kuvaus',
  'features': 'Ominaisuudet',
  'specifications': 'Tekniset tiedot',
};
